import React from 'react';
import PropTypes from 'prop-types';
import {
  Button,
} from '@material-ui/core';
import Dashboard3Drawers from '../dashboard-3-drawers/Dashboard3Drawers';
import SeedAuthenticationRepository from '../../repository/SeedAuthenticationRepository';
import seedDrawerRoutes from '../../route/seed-drawer-routes';
import { drawerRoutesPropTypes, dashboard3DrawersIconsPropTypes } from '../dashboard-3-drawers/d3d-prop-types';
import seedLogo from '../../images/logo.svg';
import { seedDashboard3DrawersIcons } from '../../icon/seed-icons';

const SeedWidgetsPage = (props) => {
  const {
    AuthenticationRepository,
    drawerRoutes,
    applicationName,
    logo,
    icons,
  } = props;

  return (
    <Dashboard3Drawers
      titleId="seed.widgets.title"
      routes={drawerRoutes}
      AuthenticationRepository={AuthenticationRepository}
      applicationName={applicationName}
      logo={logo}
      icons={icons}
    >
      <Button variant="outlined" color="primary" href="/widgets/my-snackbar">
        MySnackbar
      </Button>
      <Button variant="outlined" color="primary" href="/widgets/my-linearprogress">
        MyLinearProgress
      </Button>
    </Dashboard3Drawers>
  );
};

SeedWidgetsPage.propTypes = {
  AuthenticationRepository: PropTypes.func,
  applicationName: PropTypes.string,
  logo: PropTypes.string,
  drawerRoutes: drawerRoutesPropTypes,
  icons: dashboard3DrawersIconsPropTypes,
};

SeedWidgetsPage.defaultProps = {
  AuthenticationRepository: SeedAuthenticationRepository,
  applicationName: 'react-seed',
  logo: seedLogo,
  drawerRoutes: seedDrawerRoutes,
  icons: seedDashboard3DrawersIcons,
};

export default SeedWidgetsPage;
